module.exports = __webpack_public_path__ + "static/img/Aj-Brimson.d87d6f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Aj-Brimson.jpg
// module id = uQuP
// module chunks = 0